import React from "react";
import logo from "../../Images/ZMCLogo-2.png";
const Port = () => {
  return (
    <div className="h-screen flex justify-center items-center">
      <img src={logo} alt="" />
    </div>
  );
};

export default Port;
